const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { MomentTransferred } from './MomentTransferred';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { acquiredType } from './MomentOwned';

export class GiftingList extends BaseObject {
  public moments: MomentTransferred[] = null
  public numMoments: number = null
  public computedDate: Date = null
  public senderAddress: string = null
  public receiverAddress: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.moments) this.moments = this.moments.map((po) => new MomentTransferred(po))
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
  }

  public isSafe(): boolean {
    return true
  }


}




(async () => {
})();
